module.exports = __webpack_public_path__ + "img/laboratorio_3-4_1152.3ad7aff7.webp";